/**
 * Site-wide behaviour: close the mobile menu drawer with Escape,
 * on an outside click, or when the screen widens to desktop.
 */
(() => {
  const drawer = document.querySelector('[data-drawer]');
  if (!drawer) return;

  const close = () => drawer.removeAttribute('open');

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.open) {
      close();
      drawer.querySelector('summary').focus();
    }
  });

  document.addEventListener('click', (event) => {
    if (drawer.open && !drawer.contains(event.target)) close();
  });

  window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
    if (event.matches) close();
  });
})();
